import React from 'react'

import { apiEndpoints } from 'api/common'
import NestedFieldWidget from 'app/components/NestedFieldWIdget'
import {
  commonAttributes,
  tableColumnDefaultOption,
  uploadPresets
} from 'app/config'
import constants from 'app/constants'
import { validateNotEmpty } from 'app/validators'

// Shared column config for the two extracurricular subject variants
// (Playdate, Toddler Club). The two were byte-identical in the per-page
// configs they replace.
export const columns = [
  {
    ...commonAttributes.uuid
  },
  {
    name: 'name',
    label: 'Subject Name',
    validate: validateNotEmpty,
    maxCharacters: 60,
    options: {
      ...tableColumnDefaultOption.options,
      filterKey: 'subject'
    }
  },
  {
    name: 'internal_name',
    label: 'Internal Subject Name',
    validate: validateNotEmpty,
    options: {
      ...tableColumnDefaultOption.options,
      filterKey: 'internal_name',
      setCellProps: () => ({
        style: { minWidth: '200px', maxWidth: '200px', whiteSpace: 'pre-wrap' }
      })
    }
  },
  {
    name: 'description',
    label: 'Subject Description',
    validate: validateNotEmpty,
    maxCharacters: 250,
    options: {
      ...tableColumnDefaultOption.options,
      filterKey: 'description',
      setCellProps: () => ({
        style: { minWidth: '500px', maxWidth: '500px', whiteSpace: 'pre-wrap' }
      })
    }
  },
  {
    name: 'centres',
    label: 'Centres enabled for',
    formDataKey: 'centres',
    widget: 'autocomplete',
    widgetFilter: true,
    minCharactersToSearch: 0,
    isValueKey: true,
    validate: validateNotEmpty,
    getStructuredValues: (data) => {
      const getItemStructure = (item) => {
        return {
          uuid: item.uuid,
          name: item.name
        }
      }
      if (Array.isArray(data)) {
        return data.map((item) => getItemStructure(item))
      } else if (Object.prototype.hasOwnProperty.call(data, 'uuid')) {
        return [getItemStructure(data)]
      } else if (Object.prototype.hasOwnProperty.call(data, 'results')) {
        return data.results.map((item) => getItemStructure(item))
      } else {
        return data.map((item) => getItemStructure(item))
      }
    },
    getFormDataValue: (data) => data.map((item) => item.uuid),
    getOptionLabelKey: 'name',
    getOptionSelectedKey: 'uuid',
    resultStructure: {
      keyName: 'centres',
      keyValue: 'uuid'
    },
    apiOptions: {
      method: 'get',
      url: apiEndpoints.centre
    },
    multiple: true,
    optional: false,
    options: {
      ...tableColumnDefaultOption.options,
      filterKey: 'centre_uuid',
      customBodyRender: (val) =>
        val?.map((centre) => centre?.name)?.join(' | '),
      setCellProps: () => ({
        style: { minWidth: '300px', maxWidth: '300px', whiteSpace: 'pre-wrap' }
      })
    }
  },
  {
    name: 'activities',
    label: 'activities',
    widget: NestedFieldWidget,
    optional: true,
    viewOnlyInModal: true,
    config: {
      optional: true,
      maxItems: 6,
      headingWithIndex: 'ACTIVITY',
      ctaLabel: '+ activity',
      fields: [
        {
          name: 'title',
          label: 'Activity Title',
          editable: true,
          optional: false,
          validate: validateNotEmpty,
          maxCharacters: 60,
          options: {
            ...tableColumnDefaultOption.options,
            disableFilter: true,
            display: false
          }
        },
        {
          name: 'description',
          label: 'Activity Description',
          editable: true,
          optional: false,
          validate: validateNotEmpty,
          maxCharacters: 250,
          options: {
            ...tableColumnDefaultOption.options,
            disableFilter: true,
            display: false
          }
        },
        {
          ...commonAttributes.files,
          type: 'fileupload',
          name: 'file',
          label: 'image *',
          validate: validateNotEmpty,
          newMedia: true,
          uploadPreset: uploadPresets[constants.SUBJECT],
          optional: false,
          options: {
            disableFilter: true
          }
        }
      ]
    },
    disabledInForm: false,
    modalEdit: true,
    options: {
      ...tableColumnDefaultOption.options,
      disableFilter: true,
      display: false
    }
  },
  {
    name: 'carousel_images',
    label: 'sneak peek',
    optional: true,
    widget: NestedFieldWidget,
    viewOnlyInModal: true,
    config: {
      optional: true,
      maxItems: 10,
      ctaLabel: '+ sneak peek image',
      fields: [
        {
          ...commonAttributes.files,
          type: 'fileupload',
          validate: validateNotEmpty,
          name: 'file',
          label: 'sneak peek image *',
          newMedia: true,
          uploadPreset: uploadPresets[constants.SUBJECT],
          optional: false,
          options: {
            disableFilter: true
          }
        }
      ]
    },
    disabledInForm: false,
    modalEdit: true,
    options: {
      ...tableColumnDefaultOption.options,
      disableFilter: true,
      display: false
    }
  },
  {
    ...commonAttributes.image,
    label: 'App Icon*',
    fileUrlOnly: true,
    validate: validateNotEmpty,
    uploadPreset: uploadPresets[constants.SUBJECT]
  },
  {
    ...commonAttributes.image,
    name: 'app_image',
    label: 'Hero Image*',
    fileUrlOnly: true,
    validate: validateNotEmpty,
    uploadPreset: uploadPresets[constants.SUBJECT]
  },
  {
    name: 'activities',
    label: 'Activity Title',
    disabledInForm: true,
    options: {
      ...tableColumnDefaultOption.options,
      disableFilter: true,
      customBodyRender: (value) =>
        value?.map((item) => item?.title)?.join(' | '),
      setCellProps: () => ({
        style: {
          minWidth: '300px',
          maxWidth: '300px',
          whiteSpace: 'pre-wrap'
        }
      })
    }
  },
  {
    name: 'important_notes',
    label: 'Important Notes',
    validate: validateNotEmpty,
    optional: true,
    options: {
      ...tableColumnDefaultOption.options,
      disableFilter: true,
      setCellProps: () => ({
        style: {
          minWidth: '300px',
          maxWidth: '300px',
          whiteSpace: 'pre-wrap'
        }
      })
    }
  }
]
